/**
 * CRM no novo desenho (lote 1): textos das páginas Empresas e Contatos do clone do RD (`/crm/empresas`, `/crm/contatos`).
 * `casca` é o rótulo do item da barra lateral da casca nova (`cadastros:casca.<chave>`).
 */
const pt = {
  casca: { empresas: 'Empresas', contatos: 'Contatos' },
  crm: {
    filiais: {
      titulo: 'Filiais',
      matriz: 'Matriz',
      tem: 'Esta empresa tem filiais?',
      empresa: 'Buscar empresa cadastrada',
      cadastrar: 'Cadastrar filial',
      criar: 'Criar filial',
      adicionar: 'Adicionar filial',
      adicionarEmpresa: 'Adicionar empresa',
      tirar: 'Tirar da lista',
      tirarDaLista: 'Tirar {{nome}} da lista',
      listaCheia_one: 'A lista chegou ao limite de {{count}} empresa. Vincule esta para adicionar mais.',
      listaCheia_other: 'A lista chegou ao limite de {{count}} empresas. Vincule estas para adicionar mais.',
      listaNoTeto_one: 'Com esta, a matriz chega ao limite de 200 filiais.',
      listaNoTeto_other: 'Com estas, a matriz chega ao limite de 200 filiais.',
      perguntaTitulo_one: 'O que fazer com a filial cadastrada?',
      perguntaTitulo_other: 'O que fazer com as filiais cadastradas?',
      perguntaTexto_one: 'Esta empresa foi cadastrada pelo Criar filial. Excluir a tira das listas e das buscas, e dá para reativá-la pelo filtro Inativas. Mantida, fica salva, sem vínculo com esta matriz.',
      perguntaTexto_other: 'Estas empresas foram cadastradas pelo Criar filial. Excluir as tira das listas e das buscas, e dá para reativá-las pelo filtro Inativas. Mantidas, ficam salvas, sem vínculo com esta matriz.',
      perguntaMista_one: 'A empresa escolhida na busca não é excluída: só sai da lista.',
      perguntaMista_other: 'As empresas escolhidas na busca não são excluídas: só saem da lista.',
      semPermissaoExcluir_one: 'Esta empresa foi cadastrada pelo Criar filial. Você não tem permissão para excluí-la: ela fica salva, sem vínculo com esta matriz.',
      semPermissaoExcluir_other: 'Estas empresas foram cadastradas pelo Criar filial. Você não tem permissão para excluí-las: elas ficam salvas, sem vínculo com esta matriz.',
      falhaExcluir_one: 'Não foi possível excluir esta empresa. Tente de novo ou mantenha-a salva.',
      falhaExcluir_other: 'Não foi possível excluir estas empresas. Tente de novo ou mantenha-as salvas.',
      preservadas_one: 'Não excluída, só saiu da lista, porque mudou depois de criada (vínculo ou mescla): {{nomes}}',
      preservadas_other: 'Não excluídas, só saíram da lista, porque mudaram depois de criadas (vínculo ou mescla): {{nomes}}',
      excluir: 'Excluir',
      salvaOutra: '{{nome}} foi salva e está na lista. Cadastre a próxima.',
      manter_one: 'Manter salva',
      manter_other: 'Manter salvas',
      cnpjDaMatriz: 'Uma filial da lista tem o mesmo CNPJ desta empresa. Tire-a da lista ou corrija o CNPJ.',
      vazio: 'Nenhuma filial.',
      vinculadas_one: '{{count}} filial vinculada à matriz',
      vinculadas_other: '{{count}} filiais vinculadas à matriz',
      desvinculada: 'Vínculo desfeito',
      desvincular: 'Desvincular',
      desvincularDe: 'Desvincular a filial {{nome}}',
      desvincularDaMatriz: 'Desvincular da matriz {{nome}}',
      desvincularTexto: '{{nome}} deixa de ser filial desta empresa. As duas continuam cadastradas.',
      desvincularMatrizTexto: 'Esta empresa deixa de ser filial de {{nome}}. As duas continuam cadastradas.',
      parcial_one: '{{feitas}} de {{total}} filial vinculada.',
      parcial_other: '{{feitas}} de {{total}} filiais vinculadas.',
      parcialResto_one: 'A matriz foi salva; vincule a filial pela ficha dela.',
      parcialResto_other: 'A matriz foi salva; vincule as filiais pela ficha dela.',
      naoSalvaTeto: 'A empresa não foi salva: a matriz chegou ao limite de 200 filiais.',
      naoSalvaLista: 'A empresa não foi salva: a lista chegou ao limite de {{n}} empresas.',
      resultadoTitulo_one: 'Faltou uma filial',
      resultadoTitulo_other: 'Faltaram filiais',
      entendi: 'Entendi',
      noTeto: 'Esta matriz chegou ao limite de 200 filiais.',
      cortadas: 'Mostrando {{mostradas}} de {{total}} filiais.',
      verTodas: 'Ver todas',
      naoVinculadas_one: 'Não vinculada à matriz: {{motivo}}',
      naoVinculadas_other: 'Não vinculadas à matriz: {{motivo}}',
    },
    empresas: {
      titulo: 'Empresas',
      criar: 'Criar empresa',
      salvarOutra: 'Salvar e criar outra',
      editar: 'Editar empresa',
      todas: 'Todas as empresas',
      minhas: 'Minhas empresas',
      responsaveis_one: '{{count}} responsável',
      responsaveis_other: '{{count}} responsáveis',
      semResponsavel: 'Sem responsável',
      sobre: 'Sobre a empresa',
      abrir: 'Abrir empresa',
      vazio: 'Nenhuma empresa encontrada.',
      ficha: 'Empresa',
      cadastro: 'Cadastro',
      contatosAssociados: 'Contatos associados',
      semContatos: 'Nenhum contato.',
      atribuicoes: 'Atribuições',
      negociacoes: 'Negociações',
      historico: 'Histórico',
      emAndamento: 'Valor total em andamento',
      vendido: 'Valor total vendido',
      perdido: 'Valor total perdido',
      totalNegociacoes: 'Total de negociações',
      ticketMedio: 'Ticket médio',
      tempoMedio: 'Tempo médio até a venda (dias)',
      semNegociacoes: 'Nenhuma negociação.',
      cadastroCompleto: 'Abrir o cadastro completo',
      selecionarTodas: 'Selecionar todas as empresas deste filtro',
    },
    contatos: {
      negociacoesCortadas: 'Mostrando as {{limite}} primeiras negociações.',
      titulo: 'Contatos',
      criar: 'Criar contato',
      salvarOutro: 'Salvar e criar outro',
      editar: 'Editar contato',
      sobre: 'Sobre o contato',
      abrir: 'Abrir contato',
      vazio: 'Nenhum contato encontrado.',
      excluirTexto: 'Você está excluindo {{n}}. As negociações continuam.',
      dados: 'Dados do contato',
      privacidade: 'Privacidade de dados',
      selecionarTodos: 'Selecionar todos os contatos deste filtro',
    },
    n: { empresa_one: '{{count}} empresa', empresa_other: '{{count}} empresas', contato_one: '{{count}} contato', contato_other: '{{count}} contatos' },
    selecionados_one: '{{count}} selecionado',
    selecionados_other: '{{count}} selecionados',
    limparSelecao: 'Limpar seleção',
    acoes: { transferir: 'Transferir', adicionar: 'Adicionar', adicionarOuAlterar: 'Adicionar ou alterar', criarNegociacao: 'Criar negociação', novaNegociacao: 'Nova negociação', exportar: 'Exportar', excluir: 'Excluir' },
    campos: {
      empresa: 'Empresa',
      contato: 'Contato',
      nomeEmpresa: 'Nome da empresa',
      nomeContato: 'Nome',
      segmento: 'Segmento',
      site: 'URL',
      resumo: 'Resumo',
      endereco: 'Endereço',
      responsavel: 'Responsável',
      seguidores: 'Seguidores',
      seguidor: 'Seguidor',
      negociacoes: 'Negociações',
      ultimoContato: 'Último contato',
      naoRealizado: 'Não realizado',
      cargo: 'Cargo',
      email: 'E-mail',
      telefone: 'Telefone',
      empresaDoContato: 'Empresa do contato',
      baseLegal: 'Contato e envio de comunicação',
      tratamento: 'Tratamento',
      tratamentoAjuda: 'Usado nas etiquetas de tratamento dos modelos de e-mail. Sem escolher, o texto sai na forma neutra.',
      sexo: 'Sexo',
      sexoAjuda: 'Define o tratamento (Sr. ou Sra.) das etiquetas dos modelos de e-mail: Masculino sai como Sr., Feminino como Sra. Sem escolher ou com Não informado, o texto sai na forma neutra.',
      razaoSocial: 'Razão social',
      razaoSocialSoLeitura: 'Só quem pode editar cadastros grava a razão social.',
      nomeFantasia: 'Nome Fantasia',
      criadoEm: 'Data de criação',
      naoPreenchido: 'Não preenchido',
      naoHa: 'Não há',
    },
    tratamento: { sr: 'Sr.', sra: 'Sra.', neutro: 'Neutro' },
    sexo: { masculino: 'Masculino', feminino: 'Feminino', nao_informado: 'Não informado' },
    baseLegal: {
      nao_sabe: 'Não sei dizer / Não possuo base legal',
      consentimento: 'Consentimento',
      legitimo_interesse: 'Legítimo interesse',
      execucao_contrato: 'Execução de contrato',
      obrigacao_legal: 'Obrigação legal',
    },
    filtros: {
      botao: 'Filtros ({{n}})',
      titulo: 'Filtros',
      limpar: 'Limpar filtros',
      aplicar: 'Aplicar filtros',
      predefinidos: 'Filtros predefinidos',
      semPredefinido: 'Sem filtros predefinidos',
      grupoVendas: 'Vendas',
      grupoNegociacoes: 'Negociações',
      vendas: {
        recorrentes: 'Vendas recorrentes (2 ou mais)',
        recentes: 'Vendas recentes (30 dias)',
        antigas: 'Vendas há mais de 3 meses',
        com: 'Com vendas',
        sem: 'Sem vendas',
        andamento: 'Negociações em andamento',
        contato_recente: 'Negociação com contato recente',
        sem_negociacao: 'Novas empresas sem negociação',
      },
      criadoDesde: 'Criado de',
      criadoAte: 'Criado até',
      ultimoContatoDesde: 'Último contato a partir de',
      ultimaVendaDesde: 'Última venda a partir de',
      quantidade: {
        total: 'Quantidade total de negociações',
        abertas: 'Quantidade de negociações em andamento',
        ganhas: 'Quantidade de negociações vendidas',
        perdidas: 'Quantidade de negociações perdidas',
        pausadas: 'Quantidade de negociações pausadas',
      },
      de: 'De',
      ate: 'Até',
      vazio: 'Campos vazios',
      nenhum: 'Nenhum',
      vazioOpcoes: { email: 'E-mail', telefone: 'Telefone', cargo: 'Cargo', empresa: 'Empresa' },
      processamento: 'Processamento de dados',
      todos: 'Todos',
      salvos: 'Os filtros salvos ficam no seletor de visões da lista.',
    },
    massa: {
      confirmarPergunta: 'Para confirmar, digite quantos registros serão alterados',
      contagemErrada: 'Digite {{n}} para confirmar',
      transferirTitulo: 'Deseja transferir as empresas?',
      transferirTexto: 'Você está transferindo {{n}} para {{nome}}.',
      transferirBotao: 'Transferir empresas',
      segmentoTitulo: 'Adicionar segmento',
      segmentoTexto: 'Você está alterando o segmento de {{n}}.',
      segmentoBotao: 'Adicionar segmento',
      seguidorTitulo: 'Adicionar seguidor',
      seguidorTexto: 'Você está adicionando um seguidor em {{n}}.',
      seguidorBotao: 'Adicionar seguidor',
      baseLegalTitulo: 'Definição de bases legais',
      baseLegalTexto: 'Você está alterando a base legal de {{n}}.',
      baseLegalBotao: 'Definir base legal',
      excluirTitulo: 'Deseja excluir os registros?',
      excluirBotao: 'Excluir',
      feito_one: '{{count}} registro alterado',
      feito_other: '{{count}} registros alterados',
      falhas_one: '{{count}} não foi alterado: {{motivo}}',
      falhas_other: '{{count}} não foram alterados. Primeiro motivo: {{motivo}}',
      limite: 'Selecione até {{n}} registros por vez',
      exportado: 'Exportação concluída',
    },
    negociacao: {
      titulo: 'Criar negociação',
      nome: 'Nome da negociação',
      criada_one: '{{count}} negociação criada',
      criada_other: '{{count}} negociações criadas',
      parcial: '{{feitos}} de {{total}} negociações criadas. As criadas saíram da lista; envie de novo para criar as que faltam.',
      semPipeline: 'O Comercial não está disponível para você.',
    },
    estadoNegociacao: { aberta: 'Em andamento', ganha: 'Vendida', perdida: 'Perdida' },
    lbEmpresa: {
      todos: 'Todos',
      todosAjuda: 'Todos: a empresa não tem carteira separada e entra em "Minhas empresas" de todo mundo. Tire se ela for só de quem está na lista.',
      abrirLinkedin: 'Abrir o LinkedIn {{perfil}}',
      historicoAjuda: 'Tudo o que envolve a empresa no sistema: ela, os contatos, as negociações, as tarefas e as reuniões ligadas, do mais novo ao mais antigo.',
      origem: { empresa: 'Empresa', contato: 'Contato: {{nome}}', negociacao: 'Negociação: {{nome}}', tarefa: 'Tarefa: {{nome}}', reuniao: 'Reunião: {{nome}}', outro: '{{nome}}' },
      historicoCortadoRegistros: 'Mostrando o histórico de {{n}} dos {{total}} registros ligados à empresa.',
      historicoCortadoEventos: 'Mostrando os {{n}} eventos mais recentes.',
      anexou: 'anexou o arquivo',
      regimeAjuda: 'Começa a valer hoje; os períodos anteriores ficam no cadastro completo.',
      regimeSoLeitura: 'Só quem edita os cadastros altera o regime.',
    },
    aj: {
      abrirNegociacao: 'Abrir negociação',
      abrirSite: 'Abrir o site {{site}}',
      acrescentar: 'Acrescentar...',
      adicionarEmail: 'Adicionar e-mail',
      adicionarTelefone: 'Adicionar telefone',
      ajudaAndamento: 'Soma das negociações em andamento da empresa',
      ajudaVendido: 'Soma das negociações vendidas da empresa',
      ajudaPerdido: 'Soma das negociações perdidas da empresa',
      anterior: 'Anterior',
      proximo: 'Próximo',
      buscar: 'Buscar',
      buscarResponsavel: 'Buscar responsável',
      cadastrarEmpresa: 'Cadastrar nova empresa',
      cargoPlaceholder: 'Digite o cargo do contato',
      nomeContatoPlaceholder: 'Digite o nome do contato',
      carteiraAjuda: 'O primeiro é o responsável principal; os outros dividem a carteira.',
      umResponsavelAjuda: 'Seu perfil escolhe um só responsável; para incluir mais de um, é preciso a permissão de editar cadastros.',
      colNegociacao: 'Negociação',
      colStatus: 'Status',
      criarFiltro: 'Criar filtro salvo',
      renomearFiltro: 'Renomear filtro salvo',
      excluirFiltro: 'Excluir filtro salvo',
      nomeFiltro: 'Nome do filtro',
      filtroSalvo: 'Filtro salvo',
      filtrosSalvos: 'Filtros salvos',
      criarSegmento: 'Criar segmento',
      novoSegmento: 'Novo segmento',
      dataUltimaVenda: 'Data da última venda',
      dataUltimoContato: 'Data do último contato',
      dicaCampos: 'Personalize o formulário de cadastro de empresa.',
      dicaCamposContato: 'Personalize o formulário de cadastro de contato.',
      criarNovosCampos: 'Criar novos campos',
      editarCampo: 'Editar {{campo}}',
      saibaMaisAjuda: 'Saiba mais na Central de Ajuda',
      empresaVinculada: 'Empresa vinculada ao contato',
      endereco: { cep: 'CEP', logradouro: 'Logradouro', numero: 'Número', bairro: 'Bairro', cidade: 'Cidade', uf: 'UF', complemento: 'Complemento' },
      estrelas: 'Qualificação {{n}} de 5',
      etapa: 'Etapa',
      funil: 'Funil',
      empresaCriada: 'Empresa criada',
      contatoCriado: 'Contato criado',
      exibindo: 'Exibindo {{n}} de {{total}}',
      filtrarPorEndereco: 'Filtrar por endereço',
      filtrarPorNome: 'Filtrar por nome',
      limpar: 'Limpar',
      linkedin: 'LinkedIn',
      maisOpcoes: 'Mais opções',
      nomeDaEmpresa: 'Nome da empresa',
      nomeDoContato: 'Nome do contato',
      observacoes: 'Observações',
      resumoEmpresa: 'Resumo da empresa',
      principal: 'principal',
      proximaTarefa: 'Próxima tarefa',
      semTarefas: 'Não há tarefas',
      empresaAdicional: 'Empresa adicional',
      qualificacao: 'Qualificação',
      qualquerData: 'Qualquer data',
      remover: 'Remover',
      removerMeio: 'Remover {{campo}}',
      tirar: 'Tirar {{nome}}',
      selecionarFiltros: 'Selecionar filtros',
      adicional: 'adicional',
      adicionar: 'Adicionar',
      cadastrarContato: 'Cadastrar novo contato',
      contatoAdicionado: 'Contato adicionado à empresa',
      empresaPrincipalTrocada: 'Empresa principal alterada',
      empresaRemovida: 'Empresa removida do contato',
      tornarPrincipal: 'Tornar principal',
      tornarPrincipalDe: 'Tornar {{nome}} a empresa principal',
      semEmpresa: 'Este contato não tem empresa.',
      sobreNegociacao: 'Sobre a negociação',
      tipoTelefone: 'Tipo do telefone {{n}}',
      valorTotal: 'Valor total',
      verMais: 'Ver mais',
      vincular: 'Vincular',
      vincularEmpresa: 'Vincular empresa',
      whatsapp: 'WhatsApp',
      presets: { hoje: 'Hoje', '7': 'Últimos 7 dias', '14': 'Últimos 14 dias', '30': 'Últimos 30 dias', '90': 'Últimos 3 meses', '180': 'Últimos 6 meses', personalizado: 'Período personalizado' },
      status: { nova: 'Nova', andamento: 'Em andamento', vendido: 'Vendido', perdido: 'Perdido', pausado: 'Pausado' },
      tiposTelefone: { comercial: 'Comercial', celular: 'Celular', residencial: 'Residencial', fax: 'Fax', outro: 'Outro', whatsapp: 'WhatsApp' },
    },
    // crm5 (E1): "Excluir" vira "Inativar" (o arquivamento de sempre, sem exclusão definitiva) e o filtro "Inativas" com "Reativar".
    // crm8 (1 e 2): as verticais do relacionamento (só leitura) e a fase do cadastro único.
    relacao: { titulo: 'Verticais', ajuda: 'Vêm das negociações e dos contratos; mudam por lá.', vazio: 'Nenhuma negociação ou contrato ainda.', ativa: 'Ativa', encerrada: 'Encerrada', desde: 'desde {{data}}', em: 'em {{data}}', todas: 'Todas', outra: 'Outra vertical', antes: 'Antes', periodo: 'Ativa de {{de}} a {{ate}}' },
    fase: { rotulo: 'Fase', todas: 'Todas as fases', lead: 'Lead', cliente: 'Cliente' },
    inativar: {
      acao: 'Inativar',
      reativar: 'Reativar',
      inativarEmpresa: 'Inativar empresa',
      reativarEmpresa: 'Reativar empresa',
      titulo: 'Inativar empresa?',
      texto: 'Inativar {{nome}}? A empresa sai das listas e das buscas; os dados, os contatos, as negociações encerradas e o histórico ficam. Dá para reativar pelo filtro "Inativas".',
      feito: 'Empresa inativada',
      reativada: 'Empresa reativada',
      emUsoTitulo: 'Esta empresa não pode ser inativada',
      emUsoTexto: 'Antes de inativar, encerre ou ajuste estes registros:',
      massaTitulo: 'Deseja inativar as empresas?',
      massaTexto: 'Você está inativando {{n}}. Elas saem das listas e podem ser reativadas pelo filtro "Inativas".',
      reativarTitulo: 'Reativar as empresas?',
      reativarTexto: 'Você está reativando {{n}}. Elas voltam às listas e às buscas.',
      reativarUmaTexto: 'Reativar {{nome}}? A empresa volta às listas e às buscas.',
      massaParcial: '{{feitos}} de {{total}} empresas alteradas. As alteradas saíram da seleção; repita para as que faltam. Motivo: {{motivo}}',
      situacao: 'Situação',
      ativas: 'Ativas',
      inativas: 'Inativas',
      selo: 'Inativa',
      vazio: 'Nenhuma empresa inativa.',
    },
    seguir: { adicionar: 'Adicionar seguidor', remover: 'Tirar {{nome}} dos seguidores' },
  },
};

const en: typeof pt = {
  casca: { empresas: 'Companies', contatos: 'Contacts' },
  crm: {
    filiais: {
      titulo: 'Branches',
      matriz: 'Head office',
      tem: 'Does this company have branches?',
      empresa: 'Search registered company',
      cadastrar: 'Register branch',
      criar: 'Create branch',
      adicionar: 'Add branch',
      adicionarEmpresa: 'Add company',
      tirar: 'Remove from the list',
      tirarDaLista: 'Remove {{nome}} from the list',
      listaCheia_one: 'The list reached the limit of {{count}} company. Link it to add more.',
      listaCheia_other: 'The list reached the limit of {{count}} companies. Link these to add more.',
      listaNoTeto_one: 'With this one, the head office reaches the limit of 200 branches.',
      listaNoTeto_other: 'With these, the head office reaches the limit of 200 branches.',
      perguntaTitulo_one: 'What should happen to the registered branch?',
      perguntaTitulo_other: 'What should happen to the registered branches?',
      perguntaTexto_one: 'This company was registered through Create branch. Deleting removes it from lists and searches, and it can be reactivated through the Inactive filter. If kept, it stays saved, not linked to this head office.',
      perguntaTexto_other: 'These companies were registered through Create branch. Deleting removes them from lists and searches, and they can be reactivated through the Inactive filter. If kept, they stay saved, not linked to this head office.',
      perguntaMista_one: 'The company chosen in the search is not deleted: it only leaves the list.',
      perguntaMista_other: 'Companies chosen in the search are not deleted: they only leave the list.',
      semPermissaoExcluir_one: 'This company was registered through Create branch. You do not have permission to delete it: it stays saved, not linked to this head office.',
      semPermissaoExcluir_other: 'These companies were registered through Create branch. You do not have permission to delete them: they stay saved, not linked to this head office.',
      falhaExcluir_one: 'This company could not be deleted. Try again or keep it saved.',
      falhaExcluir_other: 'These companies could not be deleted. Try again or keep them saved.',
      preservadas_one: 'Not deleted, it only left the list, because it changed after being created (link or merge): {{nomes}}',
      preservadas_other: 'Not deleted, they only left the list, because they changed after being created (link or merge): {{nomes}}',
      excluir: 'Delete',
      salvaOutra: '{{nome}} was saved and is on the list. Register the next one.',
      manter_one: 'Keep saved',
      manter_other: 'Keep saved',
      cnpjDaMatriz: 'A branch on the list has the same CNPJ as this company. Remove it from the list or correct the CNPJ.',
      vazio: 'No branches.',
      vinculadas_one: '{{count}} branch linked to the head office',
      vinculadas_other: '{{count}} branches linked to the head office',
      desvinculada: 'Link removed',
      desvincular: 'Unlink',
      desvincularDe: 'Unlink the branch {{nome}}',
      desvincularDaMatriz: 'Unlink from the head office {{nome}}',
      desvincularTexto: '{{nome}} stops being a branch of this company. Both stay registered.',
      desvincularMatrizTexto: 'This company stops being a branch of {{nome}}. Both stay registered.',
      parcial_one: '{{feitas}} of {{total}} branch linked.',
      parcial_other: '{{feitas}} of {{total}} branches linked.',
      parcialResto_one: 'The head office was saved; link the branch from its record.',
      parcialResto_other: 'The head office was saved; link the branches from its record.',
      naoSalvaTeto: 'The company was not saved: the head office reached the limit of 200 branches.',
      naoSalvaLista: 'The company was not saved: the list reached the limit of {{n}} companies.',
      resultadoTitulo_one: 'One branch is missing',
      resultadoTitulo_other: 'Some branches are missing',
      entendi: 'Got it',
      noTeto: 'This head office reached the limit of 200 branches.',
      cortadas: 'Showing {{mostradas}} of {{total}} branches.',
      verTodas: 'See all',
      naoVinculadas_one: 'Not linked to the head office: {{motivo}}',
      naoVinculadas_other: 'Not linked to the head office: {{motivo}}',
    },
    empresas: {
      titulo: 'Companies',
      criar: 'Create company',
      salvarOutra: 'Save and create another',
      editar: 'Edit company',
      todas: 'All companies',
      minhas: 'My companies',
      responsaveis_one: '{{count}} owner',
      responsaveis_other: '{{count}} owners',
      semResponsavel: 'No owner',
      sobre: 'About the company',
      abrir: 'Open company',
      vazio: 'No companies found.',
      ficha: 'Company',
      cadastro: 'Details',
      contatosAssociados: 'Associated contacts',
      semContatos: 'No contacts.',
      atribuicoes: 'Assignments',
      negociacoes: 'Deals',
      historico: 'History',
      emAndamento: 'Total value in progress',
      vendido: 'Total value won',
      perdido: 'Total value lost',
      totalNegociacoes: 'Total deals',
      ticketMedio: 'Average ticket',
      tempoMedio: 'Average time to sale (days)',
      semNegociacoes: 'No deals.',
      cadastroCompleto: 'Open the full record',
      selecionarTodas: 'Select all companies in this filter',
    },
    contatos: {
      negociacoesCortadas: 'Showing the first {{limite}} deals.',
      titulo: 'Contacts',
      criar: 'Create contact',
      salvarOutro: 'Save and create another',
      editar: 'Edit contact',
      sobre: 'About the contact',
      abrir: 'Open contact',
      vazio: 'No contacts found.',
      excluirTexto: 'You are deleting {{n}}. Deals remain.',
      dados: 'Contact details',
      privacidade: 'Data privacy',
      selecionarTodos: 'Select all contacts in this filter',
    },
    n: { empresa_one: '{{count}} company', empresa_other: '{{count}} companies', contato_one: '{{count}} contact', contato_other: '{{count}} contacts' },
    selecionados_one: '{{count}} selected',
    selecionados_other: '{{count}} selected',
    limparSelecao: 'Clear selection',
    acoes: { transferir: 'Transfer', adicionar: 'Add', adicionarOuAlterar: 'Add or change', criarNegociacao: 'Create deal', novaNegociacao: 'New deal', exportar: 'Export', excluir: 'Delete' },
    campos: {
      empresa: 'Company',
      contato: 'Contact',
      nomeEmpresa: 'Company name',
      nomeContato: 'Name',
      segmento: 'Segment',
      site: 'URL',
      resumo: 'Summary',
      endereco: 'Address',
      responsavel: 'Owner',
      seguidores: 'Followers',
      seguidor: 'Follower',
      negociacoes: 'Deals',
      ultimoContato: 'Last contact',
      naoRealizado: 'None yet',
      cargo: 'Job title',
      email: 'Email',
      telefone: 'Phone',
      empresaDoContato: 'Contact company',
      baseLegal: 'Contact and communication',
      tratamento: 'Form of address',
      tratamentoAjuda: 'Used by the form-of-address tags in email templates. If left empty, the text uses the neutral form.',
      sexo: 'Sex',
      sexoAjuda: 'Sets the form of address (Mr. or Ms.) of the email template tags: Male comes out as Mr., Female as Ms. If left empty or Not informed, the text uses the neutral form.',
      razaoSocial: 'Legal name',
      razaoSocialSoLeitura: 'Only people who can edit records save the legal name.',
      nomeFantasia: 'Trade name',
      criadoEm: 'Created on',
      naoPreenchido: 'Not filled in',
      naoHa: 'None',
    },
    tratamento: { sr: 'Mr.', sra: 'Ms.', neutro: 'Neutral' },
    sexo: { masculino: 'Male', feminino: 'Female', nao_informado: 'Not informed' },
    baseLegal: {
      nao_sabe: "I don't know / No legal basis",
      consentimento: 'Consent',
      legitimo_interesse: 'Legitimate interest',
      execucao_contrato: 'Performance of a contract',
      obrigacao_legal: 'Legal obligation',
    },
    filtros: {
      botao: 'Filters ({{n}})',
      titulo: 'Filters',
      limpar: 'Clear filters',
      aplicar: 'Apply filters',
      predefinidos: 'Preset filters',
      semPredefinido: 'No preset filter',
      grupoVendas: 'Sales',
      grupoNegociacoes: 'Deals',
      vendas: {
        recorrentes: 'Recurring sales (2 or more)',
        recentes: 'Recent sales (30 days)',
        antigas: 'Sales over 3 months ago',
        com: 'With sales',
        sem: 'Without sales',
        andamento: 'Deals in progress',
        contato_recente: 'Deal with recent contact',
        sem_negociacao: 'New companies without deals',
      },
      criadoDesde: 'Created from',
      criadoAte: 'Created until',
      ultimoContatoDesde: 'Last contact from',
      ultimaVendaDesde: 'Last sale from',
      quantidade: {
        total: 'Total number of deals',
        abertas: 'Number of deals in progress',
        ganhas: 'Number of deals won',
        perdidas: 'Number of deals lost',
        pausadas: 'Number of paused deals',
      },
      de: 'From',
      ate: 'To',
      vazio: 'Empty fields',
      nenhum: 'None',
      vazioOpcoes: { email: 'Email', telefone: 'Phone', cargo: 'Job title', empresa: 'Company' },
      processamento: 'Data processing',
      todos: 'All',
      salvos: 'Saved filters are in the list view selector.',
    },
    massa: {
      confirmarPergunta: 'To confirm, type how many records will change',
      contagemErrada: 'Type {{n}} to confirm',
      transferirTitulo: 'Transfer the companies?',
      transferirTexto: 'You are transferring {{n}} to {{nome}}.',
      transferirBotao: 'Transfer companies',
      segmentoTitulo: 'Add segment',
      segmentoTexto: 'You are changing the segment of {{n}}.',
      segmentoBotao: 'Add segment',
      seguidorTitulo: 'Add follower',
      seguidorTexto: 'You are adding a follower to {{n}}.',
      seguidorBotao: 'Add follower',
      baseLegalTitulo: 'Legal bases',
      baseLegalTexto: 'You are changing the legal basis of {{n}}.',
      baseLegalBotao: 'Set legal basis',
      excluirTitulo: 'Delete the records?',
      excluirBotao: 'Delete',
      feito_one: '{{count}} record changed',
      feito_other: '{{count}} records changed',
      falhas_one: '{{count}} was not changed: {{motivo}}',
      falhas_other: '{{count}} were not changed. First reason: {{motivo}}',
      limite: 'Select up to {{n}} records at a time',
      exportado: 'Export finished',
    },
    negociacao: {
      titulo: 'Create deal',
      nome: 'Deal name',
      criada_one: '{{count}} deal created',
      criada_other: '{{count}} deals created',
      parcial: '{{feitos}} of {{total}} deals created. The created ones left the list; send again to create the rest.',
      semPipeline: 'Sales is not available to you.',
    },
    estadoNegociacao: { aberta: 'In progress', ganha: 'Won', perdida: 'Lost' },
    lbEmpresa: {
      todos: 'Everyone',
      todosAjuda: 'Everyone: the company has no separate portfolio and shows up in everybody\'s "My companies". Remove it if the company belongs only to the people listed.',
      abrirLinkedin: 'Open the LinkedIn profile {{perfil}}',
      historicoAjuda: 'Everything about the company in the system: the company, its contacts, deals, and linked tasks and meetings, newest first.',
      origem: { empresa: 'Company', contato: 'Contact: {{nome}}', negociacao: 'Deal: {{nome}}', tarefa: 'Task: {{nome}}', reuniao: 'Meeting: {{nome}}', outro: '{{nome}}' },
      historicoCortadoRegistros: 'Showing the history of {{n}} of the {{total}} records linked to the company.',
      historicoCortadoEventos: 'Showing the {{n}} most recent events.',
      anexou: 'attached the file',
      regimeAjuda: 'Starts today; earlier periods stay in the full record.',
      regimeSoLeitura: 'Only people who edit records can change the tax regime.',
    },
    aj: {
      abrirNegociacao: 'Open deal',
      abrirSite: 'Open the website {{site}}',
      acrescentar: 'Add...',
      adicionarEmail: 'Add email',
      adicionarTelefone: 'Add phone',
      ajudaAndamento: 'Total of the company’s open deals',
      ajudaVendido: 'Total of the company’s won deals',
      ajudaPerdido: 'Total of the company’s lost deals',
      anterior: 'Previous',
      proximo: 'Next',
      buscar: 'Search',
      buscarResponsavel: 'Search owner',
      cadastrarEmpresa: 'Register a new company',
      cargoPlaceholder: 'Type the contact’s job title',
      nomeContatoPlaceholder: 'Type the contact’s name',
      carteiraAjuda: 'The first one is the main owner; the others share the portfolio.',
      umResponsavelAjuda: 'Your profile can pick only one owner; adding more than one needs the permission to edit records.',
      colNegociacao: 'Deal',
      colStatus: 'Status',
      criarFiltro: 'Create saved filter',
      renomearFiltro: 'Rename saved filter',
      excluirFiltro: 'Delete saved filter',
      nomeFiltro: 'Filter name',
      filtroSalvo: 'Filter saved',
      filtrosSalvos: 'Saved filters',
      criarSegmento: 'Create segment',
      novoSegmento: 'New segment',
      dataUltimaVenda: 'Last sale date',
      dataUltimoContato: 'Last contact date',
      dicaCampos: 'Customize the company form.',
      dicaCamposContato: 'Customize the contact form.',
      criarNovosCampos: 'Create new fields',
      editarCampo: 'Edit {{campo}}',
      saibaMaisAjuda: 'Learn more in the Help Center',
      empresaVinculada: 'Company linked to the contact',
      endereco: { cep: 'ZIP code', logradouro: 'Street', numero: 'Number', bairro: 'District', cidade: 'City', uf: 'State', complemento: 'Address line 2' },
      estrelas: 'Rating {{n}} of 5',
      etapa: 'Stage',
      funil: 'Pipeline',
      empresaCriada: 'Company created',
      contatoCriado: 'Contact created',
      exibindo: 'Showing {{n}} of {{total}}',
      filtrarPorEndereco: 'Filter by address',
      filtrarPorNome: 'Filter by name',
      limpar: 'Clear',
      linkedin: 'LinkedIn',
      maisOpcoes: 'More options',
      nomeDaEmpresa: 'Company name',
      nomeDoContato: 'Contact name',
      observacoes: 'Notes',
      resumoEmpresa: 'Company summary',
      principal: 'main',
      proximaTarefa: 'Next task',
      semTarefas: 'No tasks',
      empresaAdicional: 'Additional company',
      qualificacao: 'Rating',
      qualquerData: 'Any date',
      remover: 'Remove',
      removerMeio: 'Remove {{campo}}',
      tirar: 'Remove {{nome}}',
      selecionarFiltros: 'Select filters',
      adicional: 'additional',
      adicionar: 'Add',
      cadastrarContato: 'Register a new contact',
      contatoAdicionado: 'Contact added to the company',
      empresaPrincipalTrocada: 'Main company changed',
      empresaRemovida: 'Company removed from the contact',
      tornarPrincipal: 'Make main',
      tornarPrincipalDe: 'Make {{nome}} the main company',
      semEmpresa: 'This contact has no company.',
      sobreNegociacao: 'About the deal',
      tipoTelefone: 'Type of phone {{n}}',
      valorTotal: 'Total value',
      verMais: 'See more',
      vincular: 'Link',
      vincularEmpresa: 'Link company',
      whatsapp: 'WhatsApp',
      presets: { hoje: 'Today', '7': 'Last 7 days', '14': 'Last 14 days', '30': 'Last 30 days', '90': 'Last 3 months', '180': 'Last 6 months', personalizado: 'Custom period' },
      status: { nova: 'New', andamento: 'In progress', vendido: 'Won', perdido: 'Lost', pausado: 'Paused' },
      tiposTelefone: { comercial: 'Work', celular: 'Mobile', residencial: 'Home', fax: 'Fax', outro: 'Other', whatsapp: 'WhatsApp' },
    },
    relacao: { titulo: 'Verticals', ajuda: 'They come from deals and contracts; change them there.', vazio: 'No deals or contracts yet.', ativa: 'Active', encerrada: 'Closed', desde: 'since {{data}}', em: 'on {{data}}', todas: 'All', outra: 'Other vertical', antes: 'Earlier', periodo: 'Active from {{de}} to {{ate}}' },
    fase: { rotulo: 'Stage', todas: 'All stages', lead: 'Lead', cliente: 'Customer' },
    inativar: {
      acao: 'Deactivate',
      reativar: 'Reactivate',
      inativarEmpresa: 'Deactivate company',
      reativarEmpresa: 'Reactivate company',
      titulo: 'Deactivate company?',
      texto: 'Deactivate {{nome}}? The company leaves the lists and searches; data, contacts, closed deals and history remain. You can reactivate it from the "Inactive" filter.',
      feito: 'Company deactivated',
      reativada: 'Company reactivated',
      emUsoTitulo: 'This company cannot be deactivated',
      emUsoTexto: 'Before deactivating, close or adjust these records:',
      massaTitulo: 'Deactivate the companies?',
      massaTexto: 'You are deactivating {{n}}. They leave the lists and can be reactivated from the "Inactive" filter.',
      reativarTitulo: 'Reactivate the companies?',
      reativarTexto: 'You are reactivating {{n}}. They return to the lists and searches.',
      reativarUmaTexto: 'Reactivate {{nome}}? The company returns to the lists and searches.',
      massaParcial: '{{feitos}} of {{total}} companies changed. The changed ones left the selection; repeat for the rest. Reason: {{motivo}}',
      situacao: 'Status',
      ativas: 'Active',
      inativas: 'Inactive',
      selo: 'Inactive',
      vazio: 'No inactive companies.',
    },
    seguir: { adicionar: 'Add follower', remover: 'Remove {{nome}} from followers' },
  },
};

const es: typeof pt = {
  casca: { empresas: 'Empresas', contatos: 'Contactos' },
  crm: {
    filiais: {
      titulo: 'Sucursales',
      matriz: 'Casa matriz',
      tem: '¿Esta empresa tiene sucursales?',
      empresa: 'Buscar empresa registrada',
      cadastrar: 'Registrar sucursal',
      criar: 'Crear sucursal',
      adicionar: 'Agregar sucursal',
      adicionarEmpresa: 'Agregar empresa',
      tirar: 'Quitar de la lista',
      tirarDaLista: 'Quitar {{nome}} de la lista',
      listaCheia_one: 'La lista llegó al límite de {{count}} empresa. Vincúlala para agregar más.',
      listaCheia_other: 'La lista llegó al límite de {{count}} empresas. Vincula estas para agregar más.',
      listaNoTeto_one: 'Con esta, la casa matriz llega al límite de 200 sucursales.',
      listaNoTeto_other: 'Con estas, la casa matriz llega al límite de 200 sucursales.',
      perguntaTitulo_one: '¿Qué hacer con la sucursal registrada?',
      perguntaTitulo_other: '¿Qué hacer con las sucursales registradas?',
      perguntaTexto_one: 'Esta empresa se registró con Crear sucursal. Eliminar la quita de las listas y las búsquedas, y puedes reactivarla con el filtro Inactivas. Si la mantienes, queda guardada, sin vínculo con esta casa matriz.',
      perguntaTexto_other: 'Estas empresas se registraron con Crear sucursal. Eliminar las quita de las listas y las búsquedas, y puedes reactivarlas con el filtro Inactivas. Si las mantienes, quedan guardadas, sin vínculo con esta casa matriz.',
      perguntaMista_one: 'La empresa elegida en la búsqueda no se elimina: solo sale de la lista.',
      perguntaMista_other: 'Las empresas elegidas en la búsqueda no se eliminan: solo salen de la lista.',
      semPermissaoExcluir_one: 'Esta empresa se registró con Crear sucursal. No tienes permiso para eliminarla: queda guardada, sin vínculo con esta casa matriz.',
      semPermissaoExcluir_other: 'Estas empresas se registraron con Crear sucursal. No tienes permiso para eliminarlas: quedan guardadas, sin vínculo con esta casa matriz.',
      falhaExcluir_one: 'No se pudo eliminar esta empresa. Inténtalo de nuevo o mantenla guardada.',
      falhaExcluir_other: 'No se pudieron eliminar estas empresas. Inténtalo de nuevo o mantenlas guardadas.',
      preservadas_one: 'No se eliminó, solo salió de la lista, porque cambió después de crearse (vínculo o fusión): {{nomes}}',
      preservadas_other: 'No se eliminaron, solo salieron de la lista, porque cambiaron después de crearse (vínculo o fusión): {{nomes}}',
      excluir: 'Eliminar',
      salvaOutra: '{{nome}} se guardó y está en la lista. Registra la siguiente.',
      manter_one: 'Mantener guardada',
      manter_other: 'Mantener guardadas',
      cnpjDaMatriz: 'Una sucursal de la lista tiene el mismo CNPJ que esta empresa. Quítala de la lista o corrige el CNPJ.',
      vazio: 'Ninguna sucursal.',
      vinculadas_one: '{{count}} sucursal vinculada a la casa matriz',
      vinculadas_other: '{{count}} sucursales vinculadas a la casa matriz',
      desvinculada: 'Vínculo deshecho',
      desvincular: 'Desvincular',
      desvincularDe: 'Desvincular la sucursal {{nome}}',
      desvincularDaMatriz: 'Desvincular de la casa matriz {{nome}}',
      desvincularTexto: '{{nome}} deja de ser sucursal de esta empresa. Ambas siguen registradas.',
      desvincularMatrizTexto: 'Esta empresa deja de ser sucursal de {{nome}}. Ambas siguen registradas.',
      parcial_one: '{{feitas}} de {{total}} sucursal vinculada.',
      parcial_other: '{{feitas}} de {{total}} sucursales vinculadas.',
      parcialResto_one: 'La casa matriz se guardó; vincula la sucursal desde su ficha.',
      parcialResto_other: 'La casa matriz se guardó; vincula las sucursales desde su ficha.',
      naoSalvaTeto: 'La empresa no se guardó: la casa matriz llegó al límite de 200 sucursales.',
      naoSalvaLista: 'La empresa no se guardó: la lista llegó al límite de {{n}} empresas.',
      resultadoTitulo_one: 'Faltó una sucursal',
      resultadoTitulo_other: 'Faltaron sucursales',
      entendi: 'Entendido',
      noTeto: 'Esta casa matriz llegó al límite de 200 sucursales.',
      cortadas: 'Se muestran {{mostradas}} de {{total}} sucursales.',
      verTodas: 'Ver todas',
      naoVinculadas_one: 'No vinculada a la casa matriz: {{motivo}}',
      naoVinculadas_other: 'No vinculadas a la casa matriz: {{motivo}}',
    },
    empresas: {
      titulo: 'Empresas',
      criar: 'Crear empresa',
      salvarOutra: 'Guardar y crear otra',
      editar: 'Editar empresa',
      todas: 'Todas las empresas',
      minhas: 'Mis empresas',
      responsaveis_one: '{{count}} responsable',
      responsaveis_other: '{{count}} responsables',
      semResponsavel: 'Sin responsable',
      sobre: 'Sobre la empresa',
      abrir: 'Abrir empresa',
      vazio: 'No se encontraron empresas.',
      ficha: 'Empresa',
      cadastro: 'Registro',
      contatosAssociados: 'Contactos asociados',
      semContatos: 'Ningún contacto.',
      atribuicoes: 'Asignaciones',
      negociacoes: 'Negociaciones',
      historico: 'Historial',
      emAndamento: 'Valor total en curso',
      vendido: 'Valor total vendido',
      perdido: 'Valor total perdido',
      totalNegociacoes: 'Total de negociaciones',
      ticketMedio: 'Ticket medio',
      tempoMedio: 'Tiempo medio hasta la venta (días)',
      semNegociacoes: 'Ninguna negociación.',
      cadastroCompleto: 'Abrir el registro completo',
      selecionarTodas: 'Seleccionar todas las empresas de este filtro',
    },
    contatos: {
      negociacoesCortadas: 'Mostrando las primeras {{limite}} negociaciones.',
      titulo: 'Contactos',
      criar: 'Crear contacto',
      salvarOutro: 'Guardar y crear otro',
      editar: 'Editar contacto',
      sobre: 'Sobre el contacto',
      abrir: 'Abrir contacto',
      vazio: 'No se encontraron contactos.',
      excluirTexto: 'Estás eliminando {{n}}. Las negociaciones siguen.',
      dados: 'Datos del contacto',
      privacidade: 'Privacidad de datos',
      selecionarTodos: 'Seleccionar todos los contactos de este filtro',
    },
    n: { empresa_one: '{{count}} empresa', empresa_other: '{{count}} empresas', contato_one: '{{count}} contacto', contato_other: '{{count}} contactos' },
    selecionados_one: '{{count}} seleccionado',
    selecionados_other: '{{count}} seleccionados',
    limparSelecao: 'Limpiar selección',
    acoes: { transferir: 'Transferir', adicionar: 'Agregar', adicionarOuAlterar: 'Agregar o cambiar', criarNegociacao: 'Crear negociación', novaNegociacao: 'Nueva negociación', exportar: 'Exportar', excluir: 'Eliminar' },
    campos: {
      empresa: 'Empresa',
      contato: 'Contacto',
      nomeEmpresa: 'Nombre de la empresa',
      nomeContato: 'Nombre',
      segmento: 'Segmento',
      site: 'URL',
      resumo: 'Resumen',
      endereco: 'Dirección',
      responsavel: 'Responsable',
      seguidores: 'Seguidores',
      seguidor: 'Seguidor',
      negociacoes: 'Negociaciones',
      ultimoContato: 'Último contacto',
      naoRealizado: 'Ninguno aún',
      cargo: 'Cargo',
      email: 'Correo',
      telefone: 'Teléfono',
      empresaDoContato: 'Empresa del contacto',
      baseLegal: 'Contacto y envío de comunicación',
      tratamento: 'Tratamiento',
      tratamentoAjuda: 'Se usa en las etiquetas de tratamiento de las plantillas de correo. Si no eliges, el texto sale en la forma neutra.',
      sexo: 'Sexo',
      sexoAjuda: 'Define el tratamiento (Sr. o Sra.) de las etiquetas de las plantillas de correo: Masculino sale como Sr., Femenino como Sra. Si no eliges o eliges No informado, el texto sale en la forma neutra.',
      razaoSocial: 'Razón social',
      razaoSocialSoLeitura: 'Solo quien puede editar registros guarda la razón social.',
      nomeFantasia: 'Nombre comercial',
      criadoEm: 'Fecha de creación',
      naoPreenchido: 'Sin completar',
      naoHa: 'No hay',
    },
    tratamento: { sr: 'Sr.', sra: 'Sra.', neutro: 'Neutro' },
    sexo: { masculino: 'Masculino', feminino: 'Femenino', nao_informado: 'No informado' },
    baseLegal: {
      nao_sabe: 'No sé / No tengo base legal',
      consentimento: 'Consentimiento',
      legitimo_interesse: 'Interés legítimo',
      execucao_contrato: 'Ejecución de contrato',
      obrigacao_legal: 'Obligación legal',
    },
    filtros: {
      botao: 'Filtros ({{n}})',
      titulo: 'Filtros',
      limpar: 'Limpiar filtros',
      aplicar: 'Aplicar filtros',
      predefinidos: 'Filtros predefinidos',
      semPredefinido: 'Sin filtros predefinidos',
      grupoVendas: 'Ventas',
      grupoNegociacoes: 'Negociaciones',
      vendas: {
        recorrentes: 'Ventas recurrentes (2 o más)',
        recentes: 'Ventas recientes (30 días)',
        antigas: 'Ventas hace más de 3 meses',
        com: 'Con ventas',
        sem: 'Sin ventas',
        andamento: 'Negociaciones en curso',
        contato_recente: 'Negociación con contacto reciente',
        sem_negociacao: 'Empresas nuevas sin negociación',
      },
      criadoDesde: 'Creado desde',
      criadoAte: 'Creado hasta',
      ultimoContatoDesde: 'Último contacto desde',
      ultimaVendaDesde: 'Última venta desde',
      quantidade: {
        total: 'Cantidad total de negociaciones',
        abertas: 'Cantidad de negociaciones en curso',
        ganhas: 'Cantidad de negociaciones vendidas',
        perdidas: 'Cantidad de negociaciones perdidas',
        pausadas: 'Cantidad de negociaciones pausadas',
      },
      de: 'Desde',
      ate: 'Hasta',
      vazio: 'Campos vacíos',
      nenhum: 'Ninguno',
      vazioOpcoes: { email: 'Correo', telefone: 'Teléfono', cargo: 'Cargo', empresa: 'Empresa' },
      processamento: 'Tratamiento de datos',
      todos: 'Todos',
      salvos: 'Los filtros guardados están en el selector de vistas de la lista.',
    },
    massa: {
      confirmarPergunta: 'Para confirmar, escribe cuántos registros cambiarán',
      contagemErrada: 'Escribe {{n}} para confirmar',
      transferirTitulo: '¿Transferir las empresas?',
      transferirTexto: 'Estás transfiriendo {{n}} a {{nome}}.',
      transferirBotao: 'Transferir empresas',
      segmentoTitulo: 'Agregar segmento',
      segmentoTexto: 'Estás cambiando el segmento de {{n}}.',
      segmentoBotao: 'Agregar segmento',
      seguidorTitulo: 'Agregar seguidor',
      seguidorTexto: 'Estás agregando un seguidor en {{n}}.',
      seguidorBotao: 'Agregar seguidor',
      baseLegalTitulo: 'Definición de bases legales',
      baseLegalTexto: 'Estás cambiando la base legal de {{n}}.',
      baseLegalBotao: 'Definir base legal',
      excluirTitulo: '¿Eliminar los registros?',
      excluirBotao: 'Eliminar',
      feito_one: '{{count}} registro cambiado',
      feito_other: '{{count}} registros cambiados',
      falhas_one: '{{count}} no se cambió: {{motivo}}',
      falhas_other: '{{count}} no se cambiaron. Primer motivo: {{motivo}}',
      limite: 'Selecciona hasta {{n}} registros por vez',
      exportado: 'Exportación terminada',
    },
    negociacao: {
      titulo: 'Crear negociación',
      nome: 'Nombre de la negociación',
      criada_one: '{{count}} negociación creada',
      criada_other: '{{count}} negociaciones creadas',
      parcial: '{{feitos}} de {{total}} negociaciones creadas. Las creadas salieron de la lista; envía de nuevo para crear las que faltan.',
      semPipeline: 'Comercial no está disponible para ti.',
    },
    estadoNegociacao: { aberta: 'En curso', ganha: 'Vendida', perdida: 'Perdida' },
    lbEmpresa: {
      todos: 'Todos',
      todosAjuda: 'Todos: la empresa no tiene cartera separada y aparece en "Mis empresas" de todos. Quítalo si la empresa es solo de quienes están en la lista.',
      abrirLinkedin: 'Abrir el LinkedIn {{perfil}}',
      historicoAjuda: 'Todo lo que involucra a la empresa en el sistema: la empresa, sus contactos, negociaciones, tareas y reuniones vinculadas, de la más nueva a la más antigua.',
      origem: { empresa: 'Empresa', contato: 'Contacto: {{nome}}', negociacao: 'Negociación: {{nome}}', tarefa: 'Tarea: {{nome}}', reuniao: 'Reunión: {{nome}}', outro: '{{nome}}' },
      historicoCortadoRegistros: 'Mostrando el historial de {{n}} de los {{total}} registros vinculados a la empresa.',
      historicoCortadoEventos: 'Mostrando los {{n}} eventos más recientes.',
      anexou: 'adjuntó el archivo',
      regimeAjuda: 'Empieza a valer hoy; los períodos anteriores quedan en el registro completo.',
      regimeSoLeitura: 'Solo quien edita los registros cambia el régimen.',
    },
    aj: {
      abrirNegociacao: 'Abrir negociación',
      abrirSite: 'Abrir el sitio {{site}}',
      acrescentar: 'Agregar...',
      adicionarEmail: 'Agregar correo',
      adicionarTelefone: 'Agregar teléfono',
      ajudaAndamento: 'Suma de las negociaciones en curso de la empresa',
      ajudaVendido: 'Suma de las negociaciones vendidas de la empresa',
      ajudaPerdido: 'Suma de las negociaciones perdidas de la empresa',
      anterior: 'Anterior',
      proximo: 'Siguiente',
      buscar: 'Buscar',
      buscarResponsavel: 'Buscar responsable',
      cadastrarEmpresa: 'Registrar nueva empresa',
      cargoPlaceholder: 'Escribe el cargo del contacto',
      nomeContatoPlaceholder: 'Escribe el nombre del contacto',
      carteiraAjuda: 'El primero es el responsable principal; los demás comparten la cartera.',
      umResponsavelAjuda: 'Tu perfil elige un solo responsable; para añadir más de uno hace falta el permiso de editar registros.',
      colNegociacao: 'Negociación',
      colStatus: 'Estado',
      criarFiltro: 'Crear filtro guardado',
      renomearFiltro: 'Renombrar filtro guardado',
      excluirFiltro: 'Eliminar filtro guardado',
      nomeFiltro: 'Nombre del filtro',
      filtroSalvo: 'Filtro guardado',
      filtrosSalvos: 'Filtros guardados',
      criarSegmento: 'Crear segmento',
      novoSegmento: 'Nuevo segmento',
      dataUltimaVenda: 'Fecha de la última venta',
      dataUltimoContato: 'Fecha del último contacto',
      dicaCampos: 'Personaliza el formulario de registro de empresa.',
      dicaCamposContato: 'Personaliza el formulario de registro de contacto.',
      criarNovosCampos: 'Crear nuevos campos',
      editarCampo: 'Editar {{campo}}',
      saibaMaisAjuda: 'Más información en el Centro de Ayuda',
      empresaVinculada: 'Empresa vinculada al contacto',
      endereco: { cep: 'Código postal', logradouro: 'Calle', numero: 'Número', bairro: 'Barrio', cidade: 'Ciudad', uf: 'Estado', complemento: 'Complemento' },
      estrelas: 'Calificación {{n}} de 5',
      etapa: 'Etapa',
      funil: 'Embudo',
      empresaCriada: 'Empresa creada',
      contatoCriado: 'Contacto creado',
      exibindo: 'Mostrando {{n}} de {{total}}',
      filtrarPorEndereco: 'Filtrar por dirección',
      filtrarPorNome: 'Filtrar por nombre',
      limpar: 'Limpiar',
      linkedin: 'LinkedIn',
      maisOpcoes: 'Más opciones',
      nomeDaEmpresa: 'Nombre de la empresa',
      nomeDoContato: 'Nombre del contacto',
      observacoes: 'Observaciones',
      resumoEmpresa: 'Resumen de la empresa',
      principal: 'principal',
      proximaTarefa: 'Próxima tarea',
      semTarefas: 'No hay tareas',
      empresaAdicional: 'Empresa adicional',
      qualificacao: 'Calificación',
      qualquerData: 'Cualquier fecha',
      remover: 'Quitar',
      removerMeio: 'Quitar {{campo}}',
      tirar: 'Quitar {{nome}}',
      selecionarFiltros: 'Seleccionar filtros',
      adicional: 'adicional',
      adicionar: 'Agregar',
      cadastrarContato: 'Registrar nuevo contacto',
      contatoAdicionado: 'Contacto agregado a la empresa',
      empresaPrincipalTrocada: 'Empresa principal cambiada',
      empresaRemovida: 'Empresa quitada del contacto',
      tornarPrincipal: 'Hacer principal',
      tornarPrincipalDe: 'Hacer de {{nome}} la empresa principal',
      semEmpresa: 'Este contacto no tiene empresa.',
      sobreNegociacao: 'Sobre la negociación',
      tipoTelefone: 'Tipo del teléfono {{n}}',
      valorTotal: 'Valor total',
      verMais: 'Ver más',
      vincular: 'Vincular',
      vincularEmpresa: 'Vincular empresa',
      whatsapp: 'WhatsApp',
      presets: { hoje: 'Hoy', '7': 'Últimos 7 días', '14': 'Últimos 14 días', '30': 'Últimos 30 días', '90': 'Últimos 3 meses', '180': 'Últimos 6 meses', personalizado: 'Período personalizado' },
      status: { nova: 'Nueva', andamento: 'En curso', vendido: 'Vendido', perdido: 'Perdido', pausado: 'Pausado' },
      tiposTelefone: { comercial: 'Comercial', celular: 'Móvil', residencial: 'Residencial', fax: 'Fax', outro: 'Otro', whatsapp: 'WhatsApp' },
    },
    relacao: { titulo: 'Verticales', ajuda: 'Vienen de las negociaciones y los contratos; cámbialas allí.', vazio: 'Todavía no hay negociaciones ni contratos.', ativa: 'Activa', encerrada: 'Cerrada', desde: 'desde el {{data}}', em: 'el {{data}}', todas: 'Todas', outra: 'Otra vertical', antes: 'Antes', periodo: 'Activa del {{de}} al {{ate}}' },
    fase: { rotulo: 'Fase', todas: 'Todas las fases', lead: 'Lead', cliente: 'Cliente' },
    inativar: {
      acao: 'Inactivar',
      reativar: 'Reactivar',
      inativarEmpresa: 'Inactivar empresa',
      reativarEmpresa: 'Reactivar empresa',
      titulo: '¿Inactivar empresa?',
      texto: '¿Inactivar {{nome}}? La empresa sale de las listas y de las búsquedas; los datos, los contactos, las negociaciones cerradas y el historial se mantienen. Se puede reactivar desde el filtro "Inactivas".',
      feito: 'Empresa inactivada',
      reativada: 'Empresa reactivada',
      emUsoTitulo: 'Esta empresa no se puede inactivar',
      emUsoTexto: 'Antes de inactivar, cierra o ajusta estos registros:',
      massaTitulo: '¿Inactivar las empresas?',
      massaTexto: 'Estás inactivando {{n}}. Salen de las listas y se pueden reactivar desde el filtro "Inactivas".',
      reativarTitulo: '¿Reactivar las empresas?',
      reativarTexto: 'Estás reactivando {{n}}. Vuelven a las listas y a las búsquedas.',
      reativarUmaTexto: '¿Reactivar {{nome}}? La empresa vuelve a las listas y a las búsquedas.',
      massaParcial: '{{feitos}} de {{total}} empresas modificadas. Las modificadas salieron de la selección; repite para las que faltan. Motivo: {{motivo}}',
      situacao: 'Situación',
      ativas: 'Activas',
      inativas: 'Inactivas',
      selo: 'Inactiva',
      vazio: 'Ninguna empresa inactiva.',
    },
    seguir: { adicionar: 'Agregar seguidor', remover: 'Quitar a {{nome}} de los seguidores' },
  },
};

export const crmPt = pt;
export const crmEn = en;
export const crmEs = es;
